module.exports = __webpack_public_path__ + "static/media/giftIcon.3670d134.png";